<template>
    <div class="panel panel-default">
        <div class="panel-body">
            <div class="row">
                <form class="form-horizontal" style="padding-top:10px" id="bs_form">

                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="col-sm-3 control-label">设备类型</label>
                            <div class="col-sm-9">
                                <select  name="lx" class="form-control" v-model="query.lx" >
                                    <option value="">-请选择-</option>
                                    <option value="android">android</option>
                                    <option value="ios">ios</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="col-sm-3 control-label">升级类型</label>
                            <div class="col-sm-9">
                                <select  name="gxlx" class="form-control" v-model="query.gxlx" >
                                    <option value="">-请选择-</option>
                                    <option value="0">建议升级</option>
                                    <option value="1">强制升级</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6 col-sm-offset-6">
                        <div class="pull-right">
                            <button @click="search()"
                                    type="button"
                                    class="btn btn-primary btn-sm"
                                    style="margin-right:3px">
                                <i class="fa fa-search" aria-hidden="true"></i>
                                查询
                            </button>

                            <button @click="addKc()"
                                    type="button"
                                    class="btn btn-primary btn-sm">
                                <i class="" aria-hidden="true"></i>
                                新增版本
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <div class="row">

                <div class="col-sm-12" style="padding-top: 10px">
                    <BootstrapTable style="font-size: 14px;"
                                    ref="table"
                                    v-once
                                    :columns="columns"
                                    :options="{
										classes:'table table-hover',
                                    	undefinedText:'',
                                        showColumns: false,
                                        sidePagination:'server',
                                        pagination:true,
                                        pageNumber:1,
                                        pageSize:10,
                                        pageList:[10,50,100,500],
                                        paginationPreText:'上一页',
                                        paginationNextText:'下一页',
                                        showExtendedPagination:true,
                                        paginationLoop:false
                                    }"
                                    @onPostBody="vueFormatterPostBody"
                                    @onPageChange="pageChange"
                                    @onClickRow="clickRow"
                    />
                </div>
            </div>
        </div>
        <!--新增组件-->
        <appversionAdd ref="appversionAdd"></appversionAdd>
        <!--编辑组件-->
        <appversionEdit ref="appversionEdit"></appversionEdit>
    </div>
</template>
<script>

    /**
     * App版本管理
     * */

    // 表格封装
    import tableMixin from '@/mixins/table.js';
    // 新增版本
    import appversionAdd from './appversionAdd.vue';
    // 编辑版本
    import appversionEdit from './appversionEdit.vue';

    export default {
        mixins: [tableMixin],

        name:"appversionList",

        // 组件
        components:{
            appversionAdd,
            appversionEdit
        },

        data:function(){
            return {
                // 查询
                query:{
                    // 设备类型
                    lx:'',
                    // 升级类型
                    gxlx:''
                },

                columns: [
                    {
                        title: '序号',
                        field: 'id',
                        align: 'center',
                        formatter: (value, row, index)=> {
                            var options = this.$refs.table.getOptions();
                            return options.pageSize * (options.pageNumber - 1) + index + 1;
                        }
                    },
                    {
                        field: 'bbh',
                        title: '版本号'
                    },
                    {
                        field: 'lx',
                        title: '设备类型'
                    },
                    {
                        field: 'url',
                        title: '下载地址'
                    },
                    {
                        field: 'gxlx',
                        title: '升级类型',
                        formatter: (value) => {
                            return value == '0' ? '建议升级' : '强制升级';
                        }
                    },
                    {
                        field: 'gxts',
                        title: '升级提示',
                    },
                    {
                        field: 'cjsj',
                        title: '创建时间'
                    },
                    {
                        field: 'xgsj',
                        title: '修改时间'
                    },
                    {
                        field: 'actions',
                        title: '操作',
                        align: 'center',
                        formatter: (value, row) => {
                            return this.vueFormatter({
                                template: `<div class="operation_column">
                                    <a @click="edit(row)">修改</a> |
                                    <a @click="remove(row)">删除</a></div>`,
                                data: { row },
                                methods: {
                                    edit: this.edit,
                                    remove: this.remove
                                }
                            })
                        }
                    }
                ]
            }
        },

        mounted(){
            this.query = Object.assign(this.query,{current:1,size:10},this.$route.query);
            this.load();
        },

        beforeRouteUpdate(to, from, next){
			this.query = Object.assign(this.query,{current:1,size:10},to.query);
            this.load();
            next();
        },

        created:function(){
            this.$store.commit('setBreadcrumb',[{name:'系统管理'},{name:'APP版本管理'}]);
        },

        methods: {
            //新增版本
            addKc:function(){
                this.$refs.appversionAdd.open();
            },

            //修改版本
            edit:function (row) {
                this.$refs.appversionEdit.open(row);
            },

            // 删除
            remove:function(row) {
                this.$confirm('确定执行此操作吗？',()=>{
                    this.$http.post('/htgl/sys/app/bbgl/sc',{id:row.id}).then(res=>{
                        if(res.data) {
                            this.$success('操作成功',()=>{
                                this.load();
                            })
                        }
                    });
                });
            },

            search:function(){
                // 将数据表格的页码以及每一页展示的数据重置为1，10
                let query = Object.assign(this.query,{current:1,size:10},{_t:new Date().getTime()});
                this.$router.push({name:this.$route.name,query:query});
            },

            // 返回表格数据
            load:function(pageNumber, pageSize){
                this.query.current = pageNumber || this.query.current;
                this.query.size = pageSize || this.query.size;
                this.$http.post('/htgl/sys/app/bbgl/cx',this.query).then(res=>{
                    let data = res.data;
                    //封装返回值
                    let result= {
                        total: data.total,
                        rows: data.records
                    };
                    //table加载返回的数据
                    this.$refs.table.load(result);
                    this.$refs.table.refreshOptions({pageNumber:parseInt(this.query.current),
                        pageSize:parseInt(this.query.size)});
                });
            },

            pageChange:function(pageNumber, pageSize){
                let query = Object.assign(this.query,{current:pageNumber,size:pageSize},{_t:new Date().getTime()});
                this.$router.push({name:this.$route.name,query:query});
            }
        }

    }
</script>
<style scoped>

</style>
